import React from "react";

const hostOf = (url) => {
  try { return new URL(url).hostname.replace(/^www\./, ""); }
  catch (e) { return ""; }
};

// Per-insight citation: the exact page the fact came from. Renders nothing
// when the backend blanked the URL (not found verbatim in the evidence).
const SourceLink = ({ url }) => {
  if (!url || !/^https?:\/\//.test(url)) return null;
  const host = hostOf(url);
  return (
    <a
      className="drSourceLink"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={url}
      onClick={(e) => e.stopPropagation()}
    >
      <i className="material-icons">open_in_new</i>
      {host || "Source"}
    </a>
  );
};

export default SourceLink;
